import { Component } from '@angular/core';
import { InjectSessionStorage, SessionStorageKey } from '@ddt-web/generic-utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JsonEditorOptions } from 'ang-jsoneditor';
import * as cloneDeep from 'lodash/cloneDeep';
import { filter } from 'rxjs/operators';

import { ConfigService } from '../../config-service';

@UntilDestroy()
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ac-config-debug-window',
	templateUrl: './config-debug-window.component.html',
	styleUrls: ['./config-debug-window.component.scss']
})
export class ConfigDebugWindowComponent {

	/**
	 * sessionConfig : This is the config object as fetched from session storage.
	 */
	@InjectSessionStorage(SessionStorageKey.Config) public sessionConfig: any;

	/**
	 * currentConfig : This is the config object that is mapped to the json-editor lib
	 */
	public currentConfig: any;
	/**
	 * modifiedConfig : This is object that stores all the modifications that the user makes until the user clicks on 'Apply'
	 */
	public modifiedConfig: any;

	public isMinimized: boolean = false;

	public editorOptions = new JsonEditorOptions();

	constructor(private configService: ConfigService) {
		// Disabling sort and transform features
		this.editorOptions.enableSort = false;
		this.editorOptions.enableTransform = false;

		// Fetching the config object as retrieved from API.
		this.configService
			.getDefaultConfigObject()
			.pipe(
				filter(value => !!value),
				untilDestroyed(this)
			)
			.subscribe((value: any) => {
				this.currentConfig = this.sessionConfig ? this.sessionConfig : value;
				this.modifiedConfig = cloneDeep(this.currentConfig);
			});
	}

	/**
	 * On click of 'Apply' Button, the modifications will be applied on the app. 
	 */
	public apply(): void {
		sessionStorage.setItem(SessionStorageKey.Config, JSON.stringify(this.modifiedConfig));
		window.location.reload();
	}

	/**
	 * On click of 'Reset' Button, the default config object(fetched from teamsite) will be applied. 
	 */
	public reset(): void {
		sessionStorage.removeItem(SessionStorageKey.Config);
		window.location.reload();
	}

	/**
	 * Once the user modifies the object in UI, the changes are saved in this variable
	 * @param config the changed object
	 */
	public getChangedConfigObject(config) {
		this.modifiedConfig = cloneDeep(config);
	}
}
